
import { Component, Vue } from 'vue-property-decorator'
import { CommonService } from '@/services'
import RecruitTable from '../components/recruit/table.vue'

@Component({
    name: 'SettingRecruit',
    components: {
        RecruitTable
    }
})
export default class extends Vue {
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = true
    private list: any = []
    
    private mounted() {
        this.getList()
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
        this.getList()
    }

    /** 获取招聘列表 */
    private async getList() {
        this.isLoading = true
        const params = {
            page_index: this.pageIndex,
            page_size: this.pageSize
        }
        const result = await CommonService.getStaffList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.list = result.data.list
        }
        this.isLoading = false
    }

    // 删除
    private onDelete(staff: any) {
        this.$confirm('你正在删除职位, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteStaff(staff)
        })
    }

    /** 删除职位 */
    private async deleteStaff(staff: any) {
        this.isLoading = true
        const params = { id: staff.id }
        const result = await CommonService.deleteStaff(params)
        this.isLoading = false
        if (result.status === 200) {
            this.list.splice(this.list.indexOf(staff), 1)
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
